// angular
import { Component, effect, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// components
import { ButtonComponent } from '@app/core/components/button/button.component';
import { GalleryComponent } from '@app/core/components/gallery/gallery.component';
// services
import { DialogService } from '@app/core/shared/services/dialog.service';
// interfaces & env
import { IMedia } from '@app/shared/interfaces/media.interface';
import { IPortfolioAboutData } from '@app/+portfolio/shared/interfaces/portfolio-about-data.interface';
import { environment } from '@environments/environment';
// pipes
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';

@Component({
  selector: 'pwj-about-section',
  standalone: true,
  imports: [
    TranslateModule,
    ButtonComponent,
    TranslateDataPipe,
    GalleryComponent,
  ],
  templateUrl: './about-section.component.html',
  styleUrl: './about-section.component.scss',
})
export class AboutSectionComponent {
  public selectedProductMedia!: IMedia;
  public baseUrl: string = environment.baseUrl.base;

  // inputs
  aboutData = input.required<IPortfolioAboutData>();

  constructor() {
    effect(() => {
      // set main image
      if (this.aboutData && this.aboutData()?.photo_urls?.length > 0) {
        this.selectedProductMedia = this.aboutData()?.photo_urls?.[0];
      }
    });
  }

  public onSelectMainImage(media: IMedia) {
    this.selectedProductMedia = media;
  }
}
